module.exports = __webpack_public_path__ + "system/static/img/toast.e0e69303.png";